export default "__VITE_ASSET__DJJWiBqY__"